import ls from "@/ls";
import dates from "@/dates";
import login
  from "../../pages/login";

/*
const get = ( name, def, check ) => {
  if ( def === undefined ) def = null;
  if ( !check ) check = v => !!v;
  
  let v = ls.get( name );
  
  if ( check !== undefined && !check( v ) ) {
    v = def;
    ls.setPermanent( "langInterf", v )
  }
  
  return v;
}
*/

const get = ( name, formatter ) => {
  let v = ls.get( name );

  let vf;
  if ( typeof( formatter ) == "function" ) vf = formatter( v );
  else vf = format( v, formatter );

  if ( v !== vf ) ls.setPermanent( name, vf );

  return v;
}

const format = ( v, def ) => {
    if ( def === undefined ) def = null;
    
    return v ? v : def;
}

const limitFormat = v => {
  v = parseInt( "" + v, 10 );
  if ( isNaN( v ) || v < 1 && v > 50 ) v = 5;
  
  return v;
};

const chunkSizeFormat = v => {
  v = parseInt( "" + v, 10 );
  if ( isNaN( v ) || ( v != 500 && v != 1000 ) ) v = 500;

  return v;
};

const dateFormat = v => {
  if ( !v || !dates.isValid( v, dates.types.RUS4Y, true ) ) v = null;
  
  return v;
};

const state = {
  langInterf:   get( "langInterf", "ru" ),
  langData:     get( "langData" ),
  dateData:     get( "dateData", dateFormat ),
  limit:        get( "limit", limitFormat ),
  chunkSize:    get( "chunkSize", chunkSizeFormat )
};

const mutations = {
  setLangInterf( state, v ) {
    v = format( v, "ru" );
    state.langInterf = v;
    ls.setPermanent( "langInterf", v );
  },
  setLangData( state, v ) {
    v = format( v );
    state.langData = v;
    ls.setPermanent( "langData", v );
  },
  setDateData( state, v ) {
    v = dateFormat( v );
    state.dateData = v;
    ls.setPermanent( "dateData", v );
  },
  setLimit( state, v ) {
    v = limitFormat( v );
    state.limit = v;
    ls.setPermanent( "limit", v );
  },
  setChunkSize( state, v ) {
    v = chunkSizeFormat( v );
    state.chunkSize = v;
    ls.setPermanent( "chunkSize", v );
  }
};

const actions = {
};

const getters = {
  getLangInterf:  state => state.langInterf,
  getLangData:    state => state.langData,
  getDateData:    state => state.dateData,
  getLimit:       state => state.limit,
  getChunkSize:   state => state.chunkSize,
};

export default {
	namespaced: true,
	strict:     true,
	state,
	mutations,
	actions,
	getters
};
